import PropTypes from 'prop-types';
import { Popover } from '@material-ui/core';
import BaseMenuItem from './BaseMenuItem';

const MenuItemWithPopover = ({
                               icon,
                               label,
                               onClick,
                               popoverOptions,
                               anchorEl,
                               setAnchorEl,
                               isLoading,
                               isSuccess,
                               isFailed,
                             }) => {
  const open = Boolean(anchorEl);

  return <>
    <BaseMenuItem
      icon={icon}
      label={label}
      onClick={(event) => {
        setAnchorEl(event.currentTarget);
        onClick?.call(this, event);
      }}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isFailed={isFailed}
    />
    {
      popoverOptions && <Popover
        id={'Filter settings popover'}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div style={{
          padding: 12,
          border: '1px solid rgb(217, 217, 217)',
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}>
          {popoverOptions}
        </div>
      </Popover>
    }
  </>;
};

MenuItemWithPopover.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  popoverOptions: PropTypes.element,
};

export default MenuItemWithPopover;
